import type { CheckoutUrlRootBuilder } from './CheckoutUrlRootBuilder';

/** Token pack — a platform purchase scoped to the authenticated creator (no creator param). */
export class TokenPackIntentBuilder {
  constructor(private readonly root: CheckoutUrlRootBuilder) {}

  /** The token-pack id (`tokenListings/:listing_id`). */
  listing(listingId: string): this {
    this.root.param('listing_id', listingId);
    return this;
  }

  quantity(qty: number): this {
    this.root.param('qty', qty);
    return this;
  }
}
